import React, { Component } from "react";
import ListingPage from "../../2/Controls/ListingPage";
import Window from "../../2/Controls/Window";
import { exportFile } from "../../../actions/DataExporter";
import ImportData from "../../ImportData";
import ImportLog from "../../ImportLog";
import Input from "../Controls/Input";
import ExportButton from "../Controls/ExportButton";
import Button from "../Controls/Button";

class StoreList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      searchParam: "",

      filter: {
        emailId: "",
        phoneNo: "",
        city: "",
        state: "",
        pincode: "",
        country: "",
        status: "active",
        customField1: "",
        customField2: "",
        customField3: "",
        customField4: "",
        customField5: "",
        customField6: ""
      },

      showFilter: false,
      showOption: false,
      showDelete: false,
      showImport: false,
      showImportLog: false,

      selectedRow: null,

      isFilterActive: false,

      customField1: "Custom Field 1",
      customField2: "Custom Field 2",
      customField3: "Custom Field 3",
      customField4: "Custom Field 4",
      customField5: "Custom Field 5",
      customField6: "Custom Field 6",

      listPageSettings: {

        Title: "Stores",

        Search: {
          showSearch: true,
          placeholder: "Search by store code, name, email id or phone no",
          onSearch: (text) => this.onSearch(text),
          onRefresh: () => this.onRefreshClick(),
          onFilterClick: () => this.setState({ showFilter: true }),
          isFilterActive: false
        },

        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
          {
            ButtonType: "ImageButton",
            Type: "option",
            Text: "Options",
            Icon: "option",
            Action: "options"
          }
        ],

        Columns: [

          { Name: "Store Code", Type: "field", Columns: [{ Column: "StoreCode" }] },

          { Name: "Store Name", Type: "field", Columns: [{ Column: "StoreName" }] },

          { Name: "EmailID", Type: "field", Columns: [{ Column: "EmailID" }] },

          { Name: "Phone No", Type: "field", Columns: [{ Column: "PhoneNo" }] },

          {
            Name: "Address",
            Type: "multiple",
            Columns: [
              { Column: "Address1" },
              { Column: "Address2" },
              { Column: "Locality" },
              { Column: "City" },
              { Column: "State" },
              { Column: "PostalCode" },
              { Column: "Country" }
            ]
          },

          {
            Name: "SMS Count",
            Type: "multiple",
            Columns: [
              { Column: "NoOfPromotionalSMS", Label: "Promotional SMS" },
              { Column: "NoOfTransactionalSMS", Label: "Transactional SMS" }
            ]
          },

          {
            Name: "Additional Info",
            Type: "multiple",
            Columns: [
              {
                Column: "CustomField1",
                Label: "Custom Field 1",
                condition: function (row) {
                  return row.hasOwnProperty("CustomField1") && row.CustomField1 !== "";
                }
              },
              {
                Column: "CustomField2",
                Label: "Custom Field 2",
                condition: function (row) {
                  return row.hasOwnProperty("CustomField2") && row.CustomField2 !== "";
                }
              },
              {
                Column: "CustomField3",
                Label: "Custom Field 3",
                condition: function (row) {
                  return row.hasOwnProperty("CustomField3") && row.CustomField3 !== "";
                }
              },
              {
                Column: "CustomField4",
                Label: "Custom Field 4",
                condition: function (row) {
                  return row.hasOwnProperty("CustomField4") && row.CustomField4 !== "";
                }
              },
              {
                Column: "CustomField5",
                Label: "Custom Field 5",
                condition: function (row) {
                  return row.hasOwnProperty("CustomField5") && row.CustomField5 !== "";
                }
              },
              {
                Column: "CustomField6",
                Label: "Custom Field 6",
                condition: function (row) {
                  return row.hasOwnProperty("CustomField6") && row.CustomField6 !== "";
                }
              }
            ]
          },

          {
            Name: "Name",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "StoreName", CSS: "bold" },
              { Column: "EmailID" },
              { Column: "PhoneNo" }
            ]
          }

        ],

        RowButtons: [
          { ButtonType: "ImageButton", Type: "view", Text: "View", Icon: "view" },
          { ButtonType: "ImageButton", Type: "edit", Text: "Edit", Icon: "edit" },
          { ButtonType: "ImageButton", Type: "delete", Text: "Delete", Icon: "delete" }
        ]

      }

    };

  }

    getExportData = async () => {

    const { filter,searchParam } = this.state;

    this.setState({ loading: true });

    const response =  await this.props.getStoresList(
       0,
        10000,
        filter.status,
  searchParam,
  filter.city,
  filter.state,
  filter.pincode,
  filter.country,
  filter.emailId,
  filter.phoneNo,
   filter.customField1,
        filter.customField2,
        filter.customField3,
        filter.customField4,
        filter.customField5,
        filter.customField6
      );

    this.setState({ loading: false });

    return response.stores || [];

  };
      
  
  
    handleExport = async (type) => {
    this.setState({ loading: true });
      try {
  
        const data =
          await this.getExportData();
  
        if (!data.length) {
  
          alert("No data found");
  
          return;
  
        }
  
         let customField1DisplayName = "";
        let customField2DisplayName = "";
        let customField3DisplayName = "";
        let customField4DisplayName = "";
        let customField5DisplayName = "";
        let customField6DisplayName = "";
  
        this.props.config.CustomFields.map((customField) => {
          if (customField.ModuleName === "Store") {
            customField1DisplayName =
              customField.CustomField1Name.trim() === ""
                ? "Custom Field 1"
                : customField.CustomField1Name.trim();
            customField2DisplayName =
              customField.CustomField2Name.trim() === ""
                ? "Custom Field 2"
                : customField.CustomField2Name.trim();
            customField3DisplayName =
              customField.CustomField3Name.trim() === ""
                ? "Custom Field 3"
                : customField.CustomField3Name.trim();
            customField4DisplayName =
              customField.CustomField4Name.trim() === ""
                ? "Custom Field 4"
                : customField.CustomField4Name.trim();
            customField5DisplayName =
              customField.CustomField5Name.trim() === ""
                ? "Custom Field 5"
                : customField.CustomField5Name.trim();
            customField6DisplayName =
              customField.CustomField6Name.trim() === ""
                ? "Custom Field 6"
                : customField.CustomField6Name.trim();
          }
        });
  
 
   const columns = [

  { header: "StoreCode", field: "StoreCode", type: "text" },
  { header: "StoreName", field: "StoreName", type: "text" },
  { header: "EmailID", field: "EmailID", type: "text" },
  { header: "PhoneNo", field: "PhoneNo", type: "text" },

  { header: "LineAddress1", field: "Address1", type: "text" },
  { header: "LineAddress2", field: "Address2", type: "text" },

  { header: "City", field: "City", type: "text" },
  { header: "StateCode", field: "StateCode", type: "text" },
  { header: "State", field: "State", type: "text" },

  { header: "PostalCode", field: "PostalCode", type: "text" },
  { header: "Country", field: "Country", type: "text" },

  { header: "Latitude", field: "Location.lat", type: "number" },
  { header: "Longitude", field: "Location.lon", type: "number" },

  {
    header: "EnableCashRegisterClosing",
    field: "CashRegisterClosing",
    type: "boolean"
  },

  {
    header: "NegativeProductQtyNotAllowedForBilling",
    field: "NegativeProductQtyNotAllowedForBilling",
    type: "boolean"
  },

  {
    header: "ChangeQtyOnPriceUpdate",
    field: "ChangeQtyOnPriceUpdate",
    type: "boolean"
  },

  
    { header: customField1DisplayName, field: "CustomField1", type: "text" },
    { header: customField2DisplayName, field: "CustomField2", type: "text" },
    { header: customField3DisplayName, field: "CustomField3", type: "text" },
    { header: customField4DisplayName, field: "CustomField4", type: "text" },
    { header: customField5DisplayName, field: "CustomField5", type: "text" },
    { header: customField6DisplayName, field: "CustomField6", type: "text" },
  ];
  
        await exportFile({
  
          data: data,
  
          columns: columns,
  
          fileType: type,
  
          title: "Store",
  
          landscape: true
  
        });
  
      }
  
      catch (error) {
  this.setState({ loading: false });
        console.error(error);
  
        alert("Export failed");
  
      }
      finally{
            this.setState({ loading: false });
      }
  
    };
  componentDidMount() {

    let customField1 = "Custom Field 1";
    let customField2 = "Custom Field 2";
    let customField3 = "Custom Field 3";
    let customField4 = "Custom Field 4";
    let customField5 = "Custom Field 5";
    let customField6 = "Custom Field 6";

    if (this.props.config && this.props.config.hasOwnProperty("CustomFields")) {

      this.props.config.CustomFields.forEach(cf => {

        if (cf.ModuleName === "Store") {

          customField1 = cf.hasOwnProperty("CustomField1Name") && cf.CustomField1Name.trim() !== "" ? cf.CustomField1Name.trim() : "Custom Field 1";
          customField2 = cf.hasOwnProperty("CustomField2Name") && cf.CustomField2Name.trim() !== "" ? cf.CustomField2Name.trim() : "Custom Field 2";
          customField3 = cf.hasOwnProperty("CustomField3Name") && cf.CustomField3Name.trim() !== "" ? cf.CustomField3Name.trim() : "Custom Field 3";
          customField4 = cf.hasOwnProperty("CustomField4Name") && cf.CustomField4Name.trim() !== "" ? cf.CustomField4Name.trim() : "Custom Field 4";
          customField5 = cf.hasOwnProperty("CustomField5Name") && cf.CustomField5Name.trim() !== "" ? cf.CustomField5Name.trim() : "Custom Field 5";
          customField6 = cf.hasOwnProperty("CustomField6Name") && cf.CustomField6Name.trim() !== "" ? cf.CustomField6Name.trim() : "Custom Field 6";

        }

      });

    }

    let listPageSettings = { ...this.state.listPageSettings };

    listPageSettings.Columns = listPageSettings.Columns.map(col => {

      if (col.Name === "Additional Info") {

        col.Columns[0].Label = customField1;
        col.Columns[1].Label = customField2;
        col.Columns[2].Label = customField3;
        col.Columns[3].Label = customField4;
        col.Columns[4].Label = customField5;
        col.Columns[5].Label = customField6;

      }

      return col;

    });

    this.setState({
      customField1,
      customField2,
      customField3,
      customField4,
      customField5,
      customField6,
      listPageSettings
    }, this.loadData);

  }

  loadData = async () => {

    this.setState({ loading: true });

    try {

      const { page, pageSize, filter, searchParam } = this.state;

      const res = await this.props.getStoresList(
          (page - 1) * pageSize,
        pageSize,
        filter.status,
  searchParam,
  filter.city,
  filter.state,
  filter.pincode,
  filter.country,
  filter.emailId,
  filter.phoneNo,
   filter.customField1,
        filter.customField2,
        filter.customField3,
        filter.customField4,
        filter.customField5,
        filter.customField6
      );

      let list = [];
      let totalCount = 0;

      if (res && res.hasOwnProperty("stores"))
        list = res.stores;

      if (res && res.hasOwnProperty("totalCount"))
        totalCount = res.totalCount;

      this.setState({
        list,
        totalCount,
        loading: false
      });

    }
    catch (error) {

      console.error(error);
      this.setState({ loading: false });

    }

  };

  deleteRecord = async () => {

    this.setState({
      loading: true,
      showDelete: false
    });

    await this.props.deleteStore(this.state.selectedRow.key);

    await new Promise(resolve => setTimeout(resolve, 3000));

    this.setState({
      loading: false,
      selectedRow: null
    });

    await this.loadData();

  };

  onSearch = (text) => {

    this.setState({
      searchParam: text,
      page: 1
    }, this.loadData);

  };

  onRefreshClick = () => {

    this.setState({

      filter: {
        emailId: "",
        phoneNo: "",
        city: "",
        state: "",
        pincode: "",
        country: "",
        status: "active",
        customField1: "",
        customField2: "",
        customField3: "",
        customField4: "",
        customField5: "",
        customField6: ""
      },

      page: 1,
      isFilterActive: false

    }, this.loadData);

  };

  onApplyFilter = () => {

    this.setState({
      showFilter: false,
      page: 1,
      isFilterActive: true
    }, this.loadData);

  };

  onClearFilter = () => {

    this.setState({

      filter: {
        emailId: "",
        phoneNo: "",
        city: "",
        state: "",
        pincode: "",
        country: "",
        status: "active",
        customField1: "",
        customField2: "",
        customField3: "",
        customField4: "",
        customField5: "",
        customField6: ""
      },

      showFilter: false,
      isFilterActive: false,
      page: 1

    }, this.loadData);

  };

  onImport = () => {

    this.setState({
      showOption: false,
      showImport: true
    });

  };

  onImportLog = () => {

    this.setState({
      showOption: false,
      showImportLog: true
    });

  };

  onCloseImport = () => {

    this.setState({
      showImport: false,
      showImportLog: false
    }, this.loadData);

  };

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "view") {

      this.props.history.push(`/home/settings/stores/viewstoredetails/${row.key}`);

    }

    if (btn.Type === "edit") {

      this.props.history.push(`/home/settings/stores/editstore/${row.key}`);

    }

    if (btn.Type === "delete") {

      this.setState({
        showDelete: true,
        selectedRow: row
      });

    }

  };

  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};
  render() {

    return (

      <>

        <ListingPage

          {...this.props}
          onPageChange={this.onPageChange}

          listPageSettings={{
            ...this.state.listPageSettings,
            Search: {
              ...this.state.listPageSettings.Search,
              isFilterActive: this.state.isFilterActive
            }
          }}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={(this.state.page - 1) * this.state.pageSize}

          itemsCountPerPage={this.state.pageSize}

          onNextClick={() =>
            this.setState({ page: this.state.page + 1 }, this.loadData)
          }

          onPreviousClick={() =>
            this.setState({ page: this.state.page - 1 }, this.loadData)
          }

          onFirstClick={() =>
            this.setState({ page: 1 }, this.loadData)
          }

          onLastClick={() => {

            const lastPage = Math.ceil(this.state.totalCount / this.state.pageSize);

            this.setState({ page: lastPage }, this.loadData);

          }}

          onRecordsPerPageCountChange={(size) =>
            this.setState({
              pageSize: Number(size),
              page: 1
            }, this.loadData)
          }

          onHeaderButtonClicked={(btn) => {

            if (btn.Action === "new")
              this.props.history.push("/home/settings/stores/newstore");

            if (btn.Action === "options")
              this.setState({ showOption: true });

          }}

          onRowButtonClicked={this.onRowButtonClicked}

        />

        {this.state.showFilter &&
          <Window
            header="Filter"
            size="small"
            slide
            onClose={() => this.setState({ showFilter: false })}
            onButtonClick={(action) => {

              if (action.toLowerCase() === "apply")
                this.onApplyFilter();

              else if (action.toLowerCase() === "clear")
                this.onClearFilter();

            }}
            buttons={[
              { Type: "secondary", Text: "Clear", Align: "left" },
              { Type: "primary", Text: "Apply", Align: "right" }
            ]}
          >

            <Input type="text" label="Email ID"
              value={this.state.filter.emailId}
              onChange={(v) => this.setState({ filter: { ...this.state.filter, emailId: v } })}
            />

            <Input type="number" label="Phone No"
              value={this.state.filter.phoneNo}
              onChange={(v) => this.setState({ filter: { ...this.state.filter, phoneNo: v } })}
            />

            <Input type="text" label="City"
              value={this.state.filter.city}
              onChange={(v) => this.setState({ filter: { ...this.state.filter, city: v } })}
            />

            <Input type="text" label="State"
              value={this.state.filter.state}
              onChange={(v) => this.setState({ filter: { ...this.state.filter, state: v } })}
            />

            <Input type="number" label="Pincode"
              value={this.state.filter.pincode}
              onChange={(v) => this.setState({ filter: { ...this.state.filter, pincode: v } })}
            />

            <Input type="text" label="Country"
              value={this.state.filter.country}
              onChange={(v) => this.setState({ filter: { ...this.state.filter, country: v } })}
            />

            <Input type="select" label="Status"
              value={this.state.filter.status}
              onChange={(v) => this.setState({ filter: { ...this.state.filter, status: v } })}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="all">All</option>
            </Input>

          </Window>
        }

        {this.state.showOption &&
          <Window header="Options" choiceList size="small" slide
            onClose={() => this.setState({ showOption: false })}
          >

          <div style={{ display: "flex", flexDirection: "column", gap: 10, alignItems: "center" }}>

  <ExportButton
    onExport={this.handleExport}
    loading={this.state.loading}
  />

  <Button
    type="secondary"
    text="Import"
    onClick={this.onImport}
  />

  <Button
    type="secondary"
    text="Import Log"
    onClick={this.onImportLog}
  />

</div>

          </Window>
        }

        {this.state.showImport &&
          <ImportData
            {...this.props}
            importType={"store"}
            onClose={this.onCloseImport}
            onImportCompleted={this.onCloseImport}
          />
        }

        {this.state.showImportLog &&
          <ImportLog
            {...this.props}
            importType={"store"}
            onClose={this.onCloseImport}
          />
        }

        {this.state.showDelete &&
          <Window
            header="Delete"
            modal
            onClose={() => this.setState({ showDelete: false })}
            onButtonClick={(btn) => {

              if (btn === "Yes")
                this.deleteRecord();
              else
                this.setState({ showDelete: false });

            }}
            buttons={[
              { Type: "secondary", Text: "No", Align: "left" },
              { Type: "primary", Text: "Yes", Align: "right" }
            ]}
          >
            Are you sure you want to delete?
          </Window>
        }

      </>

    );

  }

}

export default StoreList;